import dayjs from 'dayjs';
import { put } from '../../../infra/rest';
import { CommissionFilters, CommissionPaginationArgs, GetCommissionsResponse } from '../typings';

const getCommissionsAPI = async (
  filters?: CommissionFilters,
  paginationData?: CommissionPaginationArgs
): Promise<GetCommissionsResponse> => {
  const url = '/v1/channel-partner/payouts';
  const response = await put<GetCommissionsResponse>(
    url,
    {
      body: JSON.stringify({
        startDate: filters?.dateRange?.startDate === filters?.dateRange?.endDate ? dayjs().subtract(1, 'year').toISOString() : dayjs(filters?.dateRange?.startDate),
        endDate: dayjs(filters?.dateRange?.endDate).toISOString(),
        limit: 10,
        sortDirection: filters?.sort?.direction,
        paginationOptions: paginationData,
      }),
    },
    true
  );

  return response;
};

export default getCommissionsAPI;
